export default "__VITE_ASSET__530c405a__"